module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"limitedQtyLabel":"Stock limité ?","initialQtyLabel":"Quantité initiale","remainingQtyLabel":"Quantité restante"},"en":{"limitedQtyLabel":"Limited quantity?","initialQtyLabel":"Initial quantity","remainingQtyLabel":"Remaining quantity"}}')
  delete Component.options._Ctor
}
